export function elem(html) {
  var wrapper = document.createElement("div");
  wrapper.innerHTML = html;
  return wrapper.firstChild;
}
